import { render } from "./KtbTypeComponent.vue?vue&type=template&id=029c2e13&scoped=true"
import script from "./KtbTypeComponent.vue?vue&type=script&lang=js"
export * from "./KtbTypeComponent.vue?vue&type=script&lang=js"

import "./KtbTypeComponent.vue?vue&type=style&index=0&id=029c2e13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029c2e13"]])

export default __exports__